export const openModal = (type, id, name) => {
  if (type === 'MitreAttackModal') {
    document.dispatchEvent(
      new CustomEvent('@maui:modal-open', {
        detail: {
          type,
          status: 'open',
          ...id
        }
      })
    )
  } else if (typeof id === 'object') {
    document.dispatchEvent(
      new CustomEvent('@maui:modal-open', {
        detail: {
          type,
          ...id,
          status: 'open'
        }
      })
    )
  } else {
    document.dispatchEvent(
      new CustomEvent('@maui:modal-open', {
        detail: {
          type,
          id,
          name,
          status: 'open'
        }
      })
    )
  }
}

export const closeModal = (type) => {
  document.dispatchEvent(
    new CustomEvent('@maui:modal-close', {
      detail: {
        status: 'close'
      }
    })
  )
}
